/* eslint-disable max-len */

import UniswapQuestion from 'images/coin-pages/questions/uniswap.svg'

import { ICoinPageData } from '../types'

export const uniPage: ICoinPageData = {
  title: 'coin_975',
  description: 'coin_976',
  // description: 'coin_977',
  h1: (t, _, replacePlaceholders) => (
    <span
      dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Uniswap (UNI)' }) }}
    />
  ),
  questionsBlock: {
    image: UniswapQuestion,
    questions: [
      {
        title: 'coin_978',
        answer: 'coin_979',
      },
      {
        title: 'coin_980',
        answer: 'coin_981',
      },
      {
        title: 'coin_982',
        answer: 'coin_983',
      },
      {
        title: 'coin_984',
        answer: 'coin_985',
      },
    ],
  },
  whatIs: {
    text: ['coin_988'],
    paragraphs: [
      {
        title: 'coin_986',
        text: ['coin_989'],
      },
      {
        title: 'coin_987',
        text: ['coin_990'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/how-to-lend-uniswap/',
        image:
          'https://coinrabbit.io/blog/wp-content/uploads/2022/01/%D0%BE%D0%B1%D0%BB%D0%BE%D0%B6%D0%BA%D0%B0-%D1%8E%D0%BD%D0%B8%D1%81%D0%B2%D0%BE%D0%BF.png',
        imageAlt: 'Uniswap (UNI) review 5',
      },
      {
        link: 'https://coinrabbit.io/blog/how-crypto-assets-are-secured/',
        image: 'https://coinrabbit.io/blog/wp-content/uploads/2021/08/integration-52CR_LQ.png',
        imageAlt: 'Uniswap (UNI) review 6',
      },
      {
        link: 'https://coinrabbit.io/blog/guide-to-short-selling-with-coinrabbit-bear-market-loans/',
        image: 'https://coinrabbit.io/blog/wp-content/uploads/2021/06/Bear-loans.png',
        imageAlt: 'Uniswap (UNI) review 7',
      },
    ],
  },
}
